import { useState, useEffect, forwardRef } from 'react';
import PauseModal from "../modals/PauseModal"

const Timer = forwardRef(({ spec_id, modalOpen, forced_timer_stop }, ref) => {

    const [minutes_label_text, set_minutes_label_text] = useState("00");
    const [seconds_label_text, set_seconds_label_text] = useState("00");
    const [pause_resume_image, set_pause_resume_image] = useState('boto-pause.svg');
    const [pause_modal_open, set_pause_modal_open] = useState(false);
    const [running, set_running] = useState(true);

    useEffect(() => {
        let crossword_input = document.querySelector('[aria-label="crossword-input"]')
        if (!forced_timer_stop) {
            set_pause_resume_image('boto-pause.svg');
            if (crossword_input) {
                crossword_input.disabled = false
            }
            set_running(true)
        }
    }, [forced_timer_stop])


    useEffect(() => {
        let crossword_input = document.querySelector('[aria-label="crossword-input"]')
        if (modalOpen || forced_timer_stop) {
            set_pause_resume_image('boto-play.png');
            if (crossword_input) {
                crossword_input.disabled = true
            }
            set_running(false)
        } else {
            set_pause_resume_image('boto-pause.svg');
            if (crossword_input) {
                crossword_input.disabled = false
            }
            set_running(true)
        }
    }, [modalOpen, forced_timer_stop])

    useEffect(() => {
        let interval
        if (running) {
            interval = (setInterval(() => {
                if (!forced_timer_stop) {
                    let totalSeconds = parseInt(document.getElementById("minutes_label_" + spec_id).textContent) * 60 + parseInt(document.getElementById("seconds_label_" + spec_id).textContent) + 1
                    set_minutes_label_text(pad(Math.trunc(totalSeconds / 60)))
                    set_seconds_label_text(pad(totalSeconds % 60))
                }
            }, 1000));
        }
        return () => clearInterval(interval);
    }, [running, spec_id, forced_timer_stop]);

    function pad(val) {
        let valString = val + "";
        if (valString.length < 2) {
            return "0" + valString;
        } else {
            return valString;
        }
    }

    function stopResumeTimer() {
        if (running) {
            set_pause_resume_image('boto-play.png');
            set_pause_modal_open(true)
        } else {
            set_pause_resume_image('boto-pause.svg');
            set_pause_modal_open(false)
        }
        set_running(!running)
    }

    function handlePauseCloseModal() {
        set_pause_modal_open(false)
    }

    return <div className="timer inline-flex">
        <div className={`fontLora ${spec_id === 'mobile' ? 'text-[15px] md:text-[16px]' : 'text-[16px]'}`}>
            <label id={"minutes_label_" + spec_id}>{minutes_label_text}</label>:<label id={"seconds_label_" + spec_id}>{seconds_label_text}</label>
        </div>
        <div className="cursor-pointer place-self-center ml-[2px]">
            <img id={"pause_resume_image_" + spec_id} className="w-[17px] h-[17px] max-w-[17px]" onClick={stopResumeTimer} src={process.env.REACT_APP_ASSETSDIR + pause_resume_image} alt=""></img>
        </div>
        <PauseModal
            handleCloseModal={handlePauseCloseModal}
            showModal={pause_modal_open}
            stopResumeTimer={stopResumeTimer}
        />
    </div>
})

export default Timer